/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from "clsx";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { formatTime } from "../../helpers/date_time";
import { Message } from "../../interfaces/message";

type Props = {
  message: Message;
  makeActive: (id: string) => any;
};

export const MessageItem: FC<Props> = ({ message, makeActive }) => {
  return (
    <Link
      to={`/messages/${message.group_key}`}
      className={clsx('p-5 d-block rounded-2',  makeActive(message.group_key))}
    >
      <div className="d-flex flex-stack py-4">
        <div className="d-flex align-items-center">
          <div className="">
            <span className="fs-5 fw-bolder text-gray-900 text-hover-primary mb-2">{`${message.receipientfirstname} ${message.receipientlastname}`}</span>
            <div className="fw-bold text-gray-400">{message.title}</div>
          </div>
        </div>

        <div className="d-flex flex-column align-items-end ms-2">
          <span className="text-muted fs-7 mb-1">
            {formatTime(message.created_at)}
          </span>
          <span className="badge badge-sm badge-light-success">
            {!message.mark_as_read && "New"}
          </span>
        </div>
      </div>
    </Link>
  );
};
